module.exports = __webpack_public_path__ + "img/williams.2f3b3317.png";